export default __webpack_public_path__ + "static/media/Ellipse 84.88c6d613.svg";